var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"line-height":"normal"},attrs:{"wrap":"","align-baseline":""}},[_c('div',{staticClass:"caption mr-2 mb-1",class:[_vm.textClass]},[_vm._v("\n      "+_vm._s(_vm.$t('contentActiveViaAutomation'))+"\n      "),_c('router-link',{attrs:{"to":{name: 'workspace'}}},[_vm._v("\n        "+_vm._s(_vm.entry.automation_name)+"\n      ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ViaAutomation.vue?vue&type=template&id=7d887761&
// module id = 2278
// module chunks = 5